









import { Component, Vue } from 'vue-property-decorator';
import SupportedContext from '@/types/SupportedContext';
import ProductListComponent from '@/components/SearchResults/ProductListComponent.vue';
import ProductGridComponent from '@/components/SearchResults/ProductGridComponent.vue';
import ProductGridNewComponent from '@/components/SearchResults/ProductGridNewComponent.vue';
import ContentListComponent from '@/components/SearchResults/ContentListComponent.vue';
import SupportedLayout from '@/types/SupportedLayout';
import { BaseGetter, FilterGetter, SearchGetter } from '@/store/getters';

@Component({
  name: 'search-results-component',
  computed: {
    SearchGetter() {
      return SearchGetter;
    },
  },
  components: {
    'product-list-component': ProductListComponent,
    'product-grid-component': ProductGridComponent,
    'product-grid-new-component': ProductGridNewComponent,
    'content-list-component': ContentListComponent,
  },
})
export default class SearchResultsComponent extends Vue {
  // use or not the new grid functionality
  private showNewGridFunctionality = true;

  get isLoading(): boolean {
    return this.$store.getters[SearchGetter.IsLoading];
  }

  get activeSearchContext(): SupportedContext {
    return this.$store.getters[FilterGetter.ActiveSearchContext];
  }

  get activeLayout(): SupportedLayout {
    return this.$store.getters[BaseGetter.ActiveLayout];
  }

  get resultsView(): string {
    let componentName = '';
    switch (this.activeSearchContext) {
      default:
      case SupportedContext.PRODUCT:
        componentName = 'product-list-component';
        if (this.activeLayout === SupportedLayout.GRID) {
          componentName = 'product-grid-component';
          if (this.showNewGridFunctionality) {
            componentName = 'product-grid-new-component';
          }
        }
        break;
      case SupportedContext.CONTENT:
        componentName = 'content-list-component';
        break;
    }
    return componentName;
  }

  private get stateClass(): string {
    return this.activeLayout === 'list' ? 'container-box margin-top-1' : 'tile-box-container';
  }
}
